import { put } from "redux-saga/effects";
import { ssoFone } from "../../Services";

export function* SSOFoneSaga(action) {
  const payload = action.payload;
  try {
    const res = yield ssoFone(payload);

    yield put({ type: "SSO_FONE_SUCEEDED", data: res.data });
  } catch (error) {
    yield put({ type: "SSO_FONE_FAILED", data: error.message });
  }
}
